import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M590.453817,251 L716.417298,355.969568 L213.438121,959.544581 L716.417298,1563.11959 L590.453817,1668.08916 L0,959.544581 L590.453817,251 Z M1328.84912,251 L1919.30294,959.544581 L1328.84912,1668.08916 L1202.77629,1563.11959 L1705.86482,959.544581 L1202.77629,355.969568 L1328.84912,251 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCodeSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCodeSolid, _Component);

  var _super = _createSuper(IconCodeSolid);

  function IconCodeSolid() {
    _classCallCheck(this, IconCodeSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCodeSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCode",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCodeSolid.displayName = "IconCodeSolid";
  return IconCodeSolid;
}(Component);

IconCodeSolid.glyphName = 'code';
IconCodeSolid.variant = 'Solid';
IconCodeSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCodeSolid;
export { IconCodeSolid };